import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'lodash';
import DCUtil from '../util/DrawingCanvasUtil';
import DrawingUtil from '../queries/drawings/DrawingUtil';
import AnnotationUtil from '../queries/annotations/AnnotationUtil';
import { isWaveplayerComment } from '../util/VideoUtil';

import './assets/DrawingCanvasStyle.css';

const debug = require('../debug/debug')('wc:tabs:AssetAnnotationsComponent');

export default class AssetAnnotationsComponent extends React.Component {
  static propTypes = {
    shapes: PropTypes.array.isRequired,
    addingShape: PropTypes.object,
    onNewShape: PropTypes.func,
    onNewElement: PropTypes.func,
    onShapeCreated: PropTypes.func,
    onShapeDeleted: PropTypes.func,
    onShapeDrag: PropTypes.func,
    onShapeDragEnd: PropTypes.func,
    textElements: PropTypes.object,
    parent: PropTypes.object.isRequired
  };

  static defaultProps = {
    onNewShape: $.noop,
    onNewElement: $.noop,
    onShapeDeleted: $.noop
  };

  constructor(props) {
    super(props);

    this.state = {
      redraw: false,
      shapes: props.shapes,
      attachments: props.attachments
    };

    this.annotations = DCUtil.makeEmptySVG(this.props.parent.props.width, this.props.parent.props.height);
    this.dragElement = null;
    this.dragTextAreaElement = null;
    this.shapeDragElementId = null;
    this.shapeDragElement = null;
    this.activeShape = null;
  }

  componentDidMount() {
    $('body').on('keyup.deleteShape', this.onKeyUp);
    this.onReceiveShapes();
  }

  componentWillUnmount() {
    $('body').off('keyup.deleteShape', this.onKeyUp);
  }

  onKeyUp = (event) => {
    if (event.keyCode === 46) this.onDeleteActiveShape();
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.shapes !== this.props.shapes) {
      return true;
    }
    if (nextState.redraw) {
      this.setState({ redraw: false });
      return true;
    }
    return false;
  }

  componentWillMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.shapes !== this.props.shapes || prevProps.addingShape !== this.props.addingShape) {
      this.onReceiveShapes();
    }
    this.generateElementsId();
    this.handleDraggedEvent();
    if (this.activeShape) {
      this.activeShape = this.findShapeById(this.shapeDragElementId);
    }
    if (this.shapeDragElement) {
      this.shapeDragElement = document.getElementById(this.shapeDragElementId);
    }
  }

  redraw() {
    this.setState({ redraw: true });
  }

  generateElementsId() {
    const elements = DCUtil.getAllElements(this.annotations);
    for (let i = 0; i < elements.length; i++) {
      this.props.onNewElement(elements[i]);
    }
  }

  findShapeById = (id) => {
    return _.find(this.state.shapes, (shape) => {
      return id === 'shape_' + shape.attachment.getCommentId();
    });
  };

  handleShapeClick = (shapeEl) => {
    if (this.shapeDragElement !== shapeEl) {
      this.shapeDragElement = $(shapeEl)[0];
      this.shapeDragElementId = shapeEl.getAttribute('id');
      this.activeShape = this.findShapeById(shapeEl.getAttribute('id'));
      if (!this.activeShape) console.log('clicked shape not found');
    }
  };

  handleShapeClickOff = () => {
    if (this.shapeDragElement !== null && this.activeShape) {
      this.shapeDragElement = null;
      this.shapeDragElementId = null;
      this.activeShape = null;
    }
  };

  onDeleteActiveShape = () => {
    if (this.activeShape) {
      this.props.onShapeDeleted(this.activeShape.comment);
      this.handleShapeClickOff();
    }
  };

  handleShapeDrag = (dragObj) => {
    if (this.shapeDragElement !== null) {
      let dragElement = $('#' + this.shapeDragElement.getAttribute('id'))[0];
      switch (this.shapeDragElement.nodeName) {
        case 'rect':
          {
            const cx = dragObj.x + parseInt((dragObj.width - 20 / this.props.parent.state.scale) / 2);
            const cy = dragObj.y + parseInt((dragObj.height - 20 / this.props.parent.state.scale) / 2);
            dragElement.setAttribute('x', dragObj.x);
            dragElement.setAttribute('y', dragObj.y);
            this.handleAttachmentDrag({ x: cx, y: cy });
          }
          break;
        case 'ellipse':
          {
            const cx = dragObj.x + dragObj.width / 2;
            const cy = dragObj.y + dragObj.height / 2;
            dragElement.setAttribute('cx', cx);
            dragElement.setAttribute('cy', cy);
            this.handleAttachmentDrag({ x: cx, y: cy });
          }
          break;
        case 'line':
          {
            const cx = parseInt((dragObj.x1 + dragObj.x2) / 2);
            const cy = parseInt((dragObj.y1 + dragObj.y2) / 2);
            dragElement.setAttribute('x1', dragObj.x1);
            dragElement.setAttribute('y1', dragObj.y1);
            dragElement.setAttribute('x2', dragObj.x2);
            dragElement.setAttribute('y2', dragObj.y2);
            $(document.getElementById('DCResizeEdge1')).css(
              'top',
              dragObj.y1 * this.props.parent.state.scale - 4 + 'px'
            );
            $(document.getElementById('DCResizeEdge1')).css(
              'left',
              dragObj.x1 * this.props.parent.state.scale - 4 + 'px'
            );
            $(document.getElementById('DCResizeEdge2')).css(
              'top',
              dragObj.y2 * this.props.parent.state.scale - 4 + 'px'
            );
            $(document.getElementById('DCResizeEdge2')).css(
              'left',
              dragObj.x2 * this.props.parent.state.scale - 4 + 'px'
            );
            this.handleAttachmentDrag({ x: cx, y: cy });
          }
          break;
        default:
          console.log('unknown shape');
          break;
      }
      this.updateActiveShape(DCUtil.xmlToString(dragElement));
    }
  };

  handleMarkerDrag = (dragObj) => {
    if (this.shapeDragElement !== null) {
      let dragElement = $('#' + this.shapeDragElement.getAttribute('id'))[0];
      switch (this.shapeDragElement.nodeName) {
        case 'rect':
          {
            dragElement.setAttribute('x', dragObj.x);
            dragElement.setAttribute('y', dragObj.y);
          }
          break;
        case 'ellipse':
          {
            dragElement.setAttribute('cx', dragObj.x);
            dragElement.setAttribute('cy', dragObj.y);
          }
          break;
        case 'line':
          {
            dragElement.setAttribute('x1', dragObj.x1);
            dragElement.setAttribute('y1', dragObj.y1);
            dragElement.setAttribute('x2', dragObj.x2);
            dragElement.setAttribute('y2', dragObj.y2);
          }
          break;
        default:
          console.log('unknown shape');
          break;
      }
      this.updateActiveShape(DCUtil.xmlToString(dragElement));
    }
  };

  handleAttachmentDrag(evt) {
    this.props.onShapeDrag(this.activeShape, evt);
  }

  handleShapeDragEnd = () => {
    this.props.onShapeDragEnd(this.activeShape);
  };

  updateActiveShape = (svg) => {
    this.activeShape.attachment.setData(svg);
  };

  handleShapeResize = (resizeObj) => {
    if (this.shapeDragElement !== null) {
      let resizeElement = $('#' + this.shapeDragElement.getAttribute('id'))[0];
      switch (this.shapeDragElement.nodeName) {
        case 'rect':
          {
            resizeElement.setAttribute('width', resizeObj.width);
            resizeElement.setAttribute('height', resizeObj.height);
            resizeElement.setAttribute('x', resizeObj.x);
            resizeElement.setAttribute('y', resizeObj.y);
            const cx = resizeObj.x + parseInt(resizeObj.width / 2);
            const cy = resizeObj.y + parseInt(resizeObj.height / 2);
            this.handleAttachmentDrag({ x: cx, y: cy });
          }
          break;
        case 'ellipse':
          {
            let cx = resizeObj.x + resizeObj.width / 2;
            let cy = resizeObj.y + resizeObj.height / 2;
            let rx = resizeObj.width / 2;
            let ry = resizeObj.height / 2;
            resizeElement.setAttribute('cx', cx);
            resizeElement.setAttribute('cy', cy);
            resizeElement.setAttribute('rx', rx);
            resizeElement.setAttribute('ry', ry);
            this.handleAttachmentDrag({ x: cx, y: cy });
          }
          break;
        case 'line':
          {
            resizeElement.setAttribute('x1', resizeObj.x1);
            resizeElement.setAttribute('y1', resizeObj.y1);
            resizeElement.setAttribute('x2', resizeObj.x2);
            resizeElement.setAttribute('y2', resizeObj.y2);
            const cx = parseInt((parseInt(resizeObj.x1) + parseInt(resizeObj.x2)) / 2);
            const cy = parseInt((parseInt(resizeObj.y1) + parseInt(resizeObj.y2)) / 2);
            this.handleAttachmentDrag({ x: cx, y: cy });
          }
          break;
      }
      this.updateActiveShape(DCUtil.xmlToString(resizeElement));
    }
  };

  handleDragStart(element) {
    $(element).on('mousedown', (event) => {
      if (this.dragElement !== event.currentTarget) {
        this.dragElement = $('foreignObject')[0];
        this.dragTextAreaElement = $('foreignObject textarea')[0];

        this.props.parent.clearLostInputFocusInterval();
        this.props.parent.clearFontPickerDisappearInterval();
        $('foreignObject textarea').off('mouseleave');
        $('foreignObject textarea').off('mouseenter');
        this.props.parent.refs.addTextComp.dropClick = true;
      }
    });
  }

  handleDraggedEvent() {
    let scope = this;
    $(this.props.parent.refs.container).off('mousemove');
    $(this.props.parent.refs.container).on('mousemove', (event) => {
      if (this.dragElement !== null && this.dragTextAreaElement !== null) {
        event.preventDefault();
        const scale = this.props.parent.state.scale;
        let foreingObject = this.dragElement;
        let textArea = this.dragTextAreaElement;
        let x = 0,
          y = 0;
        const HANDLE_WIDTH = parseInt($(textArea).css('width')) * scale;
        const HANDLE_HEIGHT = parseInt($(textArea).css('height')) * scale + 30;
        if (scale < 1) {
          const width = this.props.parent.props.width * scale;
          const height = this.props.parent.props.height * scale;
          const maxX = width - HANDLE_WIDTH - 1;
          const maxY = height - HANDLE_HEIGHT;
          x = event.pageX - this.props.parent.state.offsetX;
          y = event.pageY - this.props.parent.state.offsetY - 70;
          if (x < 0) x = 0;
          if (y < 0) y = 0;
          if (x > maxX) x = maxX;
          if (y > maxY) y = maxY;
        } else {
          const rect = $(this.props.parent.refs.container)
            .get(0)
            .getBoundingClientRect();
          const maxX = rect.width - HANDLE_WIDTH;
          const maxY = rect.height - HANDLE_HEIGHT;
          x = event.pageX - rect.left;
          y = event.pageY - rect.top;
          if (x > maxX) x = maxX;
          if (y > maxY) y = maxY;
        }
        foreingObject.setAttribute('x', parseInt(x / scale));
        foreingObject.setAttribute('y', parseInt((y + 20) / scale) - 1);
        textArea.setAttribute('x', parseInt(x / scale));
        textArea.setAttribute('y', parseInt((y + 20) / scale));
        scope.props.parent.refs.addTextComp.onDrop({
          x: x,
          y: y
        });
      } else if (this.dragElement !== null && this.shapeDragElement !== null) {
        const spanId = this.dragElement.getAttribute('id');
        const targetId = event.target.getAttribute('id');
        if (!targetId || targetId != spanId) {
          const x = event.offsetX / this.props.parent.state.scale;
          const y = event.offsetY / this.props.parent.state.scale;
          $(this.dragElement).css('top', parseInt(y) * this.props.parent.state.scale - 4 + 'px');
          $(this.dragElement).css('left', parseInt(x) * this.props.parent.state.scale - 4 + 'px');
          if (spanId === 'DCResizeEdge1') {
            this.handleShapeResize({
              x1: x,
              y1: y,
              x2: this.shapeDragElement.getAttribute('x2'),
              y2: this.shapeDragElement.getAttribute('y2')
            });
          } else if (spanId === 'DCResizeEdge2') {
            this.handleShapeResize({
              x1: this.shapeDragElement.getAttribute('x1'),
              y1: this.shapeDragElement.getAttribute('y1'),
              x2: x,
              y2: y
            });
          }
        }
      }
    });

    $(document).on('mouseup', (event) => {
      if (this.dragElement !== null && this.shapeDragElement === null) {
        $(this.dragElement).css('pointerEvents', 'auto');
        $(this.dragTextAreaElement).css('pointerEvents', 'auto');
        event.preventDefault();
        scope.props.parent.refs.addTextComp.setOpacity(1);
        this.dragElement = null;
        this.dragTextAreaElement = null;
        $('foreignObject textarea').focus();
        setTimeout(() => {
          scope.props.parent.handleTextAreaMouseEvents();
          scope.props.parent.startLostInputFocusInterval();
        }, 250);
      } else if (this.dragElement !== null && this.shapeDragElement !== null) {
        if (this.activeShape) {
          this.props.onShapeDragEnd(this.activeShape);
        }
        this.dragElement = null;
        this.props.parent.setState({
          rndBoxState: {
            drawRndBox: true,
            allowResize: false,
            drawLineEdges: true
          }
        });
        this.props.parent.bootstrapShape();
      }
    });
  }

  isDragging() {
    return this.dragElement !== null;
  }

  isAnnotationsEmpty() {
    return this.state.shapes.length === 0 && DCUtil.getAllElements(this.props.textElements).length === 0;
  }

  makeDrawingAttachmentsArray() {
    let svgAttachments = [];
    _.each(this.props.shapes, (comment) => {
      const attachments = AnnotationUtil.getAttachmentsFromThread(comment);
      if (attachments) {
        _.each(attachments, (attachment) => {
          if (attachment.getDataType() === 'SVG') {
            svgAttachments.push({ comment, attachment });
          }
        });
      }
    });
    return svgAttachments;
  }

  onReceiveShapes() {
    let shapes = this.makeDrawingAttachmentsArray();
    // debug('[onReceiveShapes()] shapes: ', shapes);
    this.annotations = DCUtil.parseXml(this.buildSVG(shapes));
    // debug('[onReceiveShapes()] this.annotations: ', this.annotations);
    this.setState({ shapes: shapes, redraw: true });
  }

  removeElem(element) {
    let innerEl = this.props.textElements.getElementById(element.id);
    DCUtil.removeElem(innerEl);
    this.setState({ redraw: true });
  }

  placeRect(x, y, w, h, style) {
    let rect = this.annotations.createElement('rect');
    rect.setAttribute('x', x);
    rect.setAttribute('y', y);
    rect.setAttribute('width', w);
    rect.setAttribute('height', h);
    rect.setAttribute('shape', 'true');
    rect.setAttribute(
      'style',
      `fill-opacity:${style.fillOpacity};stroke-width: ${style.strokeWidth};stroke:${style.stroke};`
    );
    this.onShapeCreated(rect);
  }

  placeEllipse(cx, cy, rx, ry, style) {
    let ellipse = this.annotations.createElement('ellipse');
    ellipse.setAttribute('cx', cx);
    ellipse.setAttribute('cy', cy);
    ellipse.setAttribute('rx', rx);
    ellipse.setAttribute('ry', ry);
    ellipse.setAttribute('shape', 'true');
    ellipse.setAttribute(
      'style',
      `fill-opacity:${style.fillOpacity};stroke-width:${style.strokeWidth};stroke:${style.stroke};`
    );
    this.onShapeCreated(ellipse);
  }

  placeLine(x1, y1, x2, y2, style) {
    let line = this.annotations.createElement('line');
    line.setAttribute('x1', x1);
    line.setAttribute('y1', y1);
    line.setAttribute('x2', x2);
    line.setAttribute('y2', y2);
    line.setAttribute('shape', 'true');
    line.setAttribute('style', `fill:${style.fill};stroke-width:${style.strokeWidth};stroke:${style.stroke};`);
    this.onShapeCreated(line);
  }

  onShapeCreated = (newShape) => {
    const drawing = DrawingUtil.createSvgDrawing(DCUtil.xmlToString(newShape));
    this.props.onShapeCreated(drawing);
  };

  static cleanDataField(data) {
    try {
      const json = JSON.parse(data);
      return json['_data'];
    } catch (e) {
      return data;
    }
  }

  static appendShapeId(svg, id) {
    let xml = DCUtil.parseXml(svg, id);
    let el = xml.firstChild;
    el.setAttribute('id', 'shape_' + id);
    svg = DCUtil.xmlToString(xml);
    return svg;
  }

  buildSVG(shapes) {
    let svg = `<svg width="${this.props.parent.props.width}"
        height="${this.props.parent.props.height}"
        viewBox="${0} ${0} ${this.props.parent.props.width} ${this.props.parent.props.height}"
        xmlns="http://www.w3.org/2000/svg">`;

    _.each(shapes, (shape) => {
      if (isWaveplayerComment(shape.comment)) {
        return;
      }
      shape.attachment.setData(AssetAnnotationsComponent.cleanDataField(shape.attachment.getData().toString()));
      svg += AssetAnnotationsComponent.appendShapeId(shape.attachment.getData(), shape.attachment.getCommentId());
    });

    const attachments = AnnotationUtil.getAttachmentsFromThread(this.props.addingShape);
    if (attachments) {
      _.each(attachments, (attachment) => {
        if (attachment.getDataType() === 'SVG') {
          svg += attachment.getData();
        }
      });
    }

    const textEls = DCUtil.getAllElements(this.props.textElements);
    _.each(textEls, (text) => {
      svg += DCUtil.xmlToString(text);
    });

    svg += '</svg>';
    return svg;
  }

  getSVG() {
    return DCUtil.xmlToString(this.annotations);
  }

  render() {
    if (!this.annotations) return null;
    return <div dangerouslySetInnerHTML={{ __html: DCUtil.xmlToString(this.annotations) }} />;
  }
}
